import { useAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_decor-and-style/artifacts/89wv37zw_LOGO.png";

export default function Login() {
  const { user } = useAuth();

  if (user) {
    return <Navigate to={user.is_admin ? '/admin' : '/'} replace />;
  }

  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/admin';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A1128] px-6" data-testid="login-page">
      <div className="w-full max-w-md text-center">
        <img src={LOGO_URL} alt="Style and Space" className="w-20 h-20 rounded-full object-cover mx-auto mb-8 border-2 border-white/20" />
        <h1 className="font-['Playfair_Display'] text-4xl font-bold text-white mb-3">
          Style & Space
        </h1>
        <p className="text-white/50 text-sm uppercase tracking-[0.2em] mb-12">Admin Portal</p>

        <button
          onClick={handleGoogleLogin}
          className="w-full bg-white text-[#0A1128] px-8 py-4 text-sm uppercase tracking-widest font-semibold hover:bg-white/90 transition-all flex items-center justify-center gap-3"
          data-testid="google-login-btn"
        >
          <svg className="w-5 h-5" viewBox="0 0 24 24">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
          </svg>
          Continue with Google
        </button>

        <p className="text-white/30 text-xs mt-8 tracking-wider">
          Admin access only. First sign-in becomes admin.
        </p>
      </div>
    </div>
  );
}
